import { render, staticRenderFns } from "./ShortlistCounter.vue?vue&type=template&id=5498e45f&scoped=true&"
import script from "./ShortlistCounter.vue?vue&type=script&lang=js&"
export * from "./ShortlistCounter.vue?vue&type=script&lang=js&"
import style0 from "./ShortlistCounter.vue?vue&type=style&index=0&id=5498e45f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5498e45f",
  null
  
)

export default component.exports